import React, { useMemo, useCallback } from 'react';
import { Tab } from '../../core/components/Tab/component.js';

var NavTabs = function NavTabs(_ref) {
  var activeTab = _ref.activeTab,
      tabs = _ref.tabs,
      onChange = _ref.onChange;
  /***
   * Hooks
   */

  var memoizedDefaultIndex = useMemo(function () {
    return (activeTab === null || activeTab === void 0 ? void 0 : activeTab.routeKey) && tabs.findIndex(function (tab) {
      return tab.routeKey === activeTab.routeKey;
    });
  }, [activeTab, tabs]);
  var memoizedItems = useMemo(function () {
    return tabs.map(function (_ref2) {
      var title = _ref2.title,
          disabled = _ref2.disabled;
      return {
        title: title,
        disabled: disabled
      };
    });
  }, [tabs]);
  var handleOnChange = useCallback(function (index) {
    return onChange(tabs[index].routeKey);
  }, [onChange, tabs]);
  /***
   * DOM
   */

  return /*#__PURE__*/React.createElement(Tab, {
    defaultIndex: memoizedDefaultIndex,
    items: memoizedItems,
    onChange: handleOnChange
  });
};

NavTabs.displayName = "NavTabs";
export { NavTabs };